import { InjectionToken } from '@angular/core';
import { Environment } from './types';

export const ENVIRONMENT = new InjectionToken<Environment>('ENVIRONMENT');
export const AUTOTRAVERSAL_RULES_VERSION = new InjectionToken<string>(
  'AutotraversalRulesVersion'
);
